VIV.behaviours.blockNumbers = (function () {

    const attach = function (context) {
        context.querySelectorAll('.blockNumbers').forEach(element => {
            init(element);
        });
    };

    const init = function (element) {

    };

    return {
        attach: attach
    }
})();
